import React, { Component } from 'react'
import { connect } from 'react-redux'

import Line from '../Line'
// Utils
// import { renderFullDate } from '../../../../utils/time'
// import { hasAccess, hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../utils/auth'
import { translation } from '../../../../utils/helpers'

import './assessmentreportsums.scss'

class AssessmentReportSums extends Component {

  render () {
    if (!this.props.report) return null
    // let parent = this._reactInternalInstance._currentElement._owner._instance
    // console.log('AssessmentReportSums -> render', this.props.report, 'parent', parent)
    let currencyType = translation(this.props.currencyCode)

    const renderReportSums = (sum, i) => {
      return (
        <div className='sum' key={'sum_' + i}>
          <Line boldText text={sum.Text + ':'} amount={sum.TotalPrice} currencyType={currencyType} />
        </div>
      )
    }

    const renderDivider = () => {
      return (
        <div className='divider' />
      )
    }

    let sumsToRender = (this.props.report.Summation || []).filter(x => x.DisplayDepartment === this.props.department || this.props.department === 2)
    if (Array.isArray(this.props.includeSumTypes)) {
      sumsToRender = sumsToRender.filter(x => this.props.includeSumTypes.includes(x.SumType))
    }
    if (Array.isArray(this.props.excludeSumTypes)) {
      sumsToRender = sumsToRender.filter(x => !this.props.excludeSumTypes.includes(x.SumType))
    }

    let totalWithEnv = 0
    let total = 0
    let report = this.props.report
    switch (this.props.department) {
      case 0: // PaintShop
        total = report.Paint.TotalPrice
        totalWithEnv = report.Paint.TotalPriceWithEnv
        break
      case 1: // BodyShop
        total = report.Body.TotalPrice
        totalWithEnv = report.Body.TotalPriceWithEnv
        break
      case 2: // Both PaintShop and BodyShop
        total = (report.Body && report.Body.TotalPrice) + (report.Paint && report.Paint.TotalPrice)
        totalWithEnv = (report.Body && report.Body.TotalPriceWithEnv) + (report.Paint && report.Paint.TotalPriceWithEnv)
    }

    return (
      <div className='assessment-report-sums'>
        {sumsToRender.filter(x => x.SumType !== 4).map(renderReportSums)}
        {this.props.includeTotal && <div><Line boldText text={translation(18392) + ':'} amount={total} bold={this.props.includeTotalDivider} currencyType={translation(this.props.currencyCode)} /></div>}
        {this.props.includeTotalDivider && this.props.includeTotal && renderDivider()}
        {sumsToRender.filter(x => x.SumType === 4).map(renderReportSums)}
        {this.props.includeTotal && <div><Line boldText text={translation(393) + ':'} amount={totalWithEnv} bold={this.props.includeTotalDivider} currencyType={translation(this.props.currencyCode)} /></div>}
      </div>
    )
  }

}

AssessmentReportSums.defaultProps = {
  includeTotal: true,
  includeTotalDivider: true
  // excludeSumTypes: [0]
}

function mapStateToProps (state) {
  return {
    auth: state.auth
    // currencyCode: state.common.currencyCode
  }
}
export default connect(mapStateToProps, {})(AssessmentReportSums)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/AssessmentReportSums/index.js